import { type IConfig } from '@cian/config/shared';

import { dealTypeFromJsonQuery, FDealType, isFlat, isSuburban, offerTypeFromJsonQuery } from './category';
import { getRegionId } from './geo';
import { TJsonQuery } from '../../packages/JsonQuery';
import { IAbUseExperiment } from '../types/abUseExperiments';
import { TLocation } from '../types/location';
import { isAbUseExperimentGroup } from './experiments/isAbUseExperimentGroup';
import { BX_HYBRID_SEARCH_EXPERIMENT } from 'shared/constants/experiments';

type Params = {
  jsonQuery: TJsonQuery;
  config: IConfig;
  experiments: IAbUseExperiment[];
  location: TLocation;
};

export function isHybridSearchRedirectNeeded({ jsonQuery, config, experiments, location }: Params): boolean {
  const isFeatureEnabled = !!config.get<boolean>('BX.HybridSearch.Enabled');

  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const isCategoryValid =
    (dealType === FDealType.RentLongterm && isFlat(offerType)) ||
    (dealType === FDealType.Sale && isSuburban(offerType));

  const excludedRegions = config.get<number[]>('BX.HybridSearch.ExcludedRegions') || [];
  const regionId = getRegionId(location, true);
  const isValidRegion = !excludedRegions.includes(regionId);

  const isExperimentEnabled: boolean = isAbUseExperimentGroup(experiments, BX_HYBRID_SEARCH_EXPERIMENT, 'B');

  return isFeatureEnabled && isCategoryValid && isValidRegion && isExperimentEnabled;
}
